import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function ingredientRecipesStart({ outletIds }) {
  pushClevertapEvent('Ingredient Recipes Start', {
    'Current Selected Outlet': outletIds,
  });
}

export function ingredientRecipesChangeFilter({ currentOutlet, outletIds }) {
  pushClevertapEvent('Ingredient Recipes Change Outlet', {
    'Previous Selected Outlet': currentOutlet,
    'Current Selected Outlet': outletIds,
  });
}

export function ingredientRecipesSelect({ recipe }) {
  pushClevertapEvent('Ingredient Recipes Select', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    Ingredient: recipe.recipe_ingredients.map(ri => ({
      'Ingredient Name': ri.ingredient_name,
      'Ingredient Quantity': ri.quantity,
      'Ingredient Unit': ri.unit_name,
    })),
  });
}

export function ingredientRecipesCreate({ recipe, allOutlet, outlets }) {
  let eventName;
  if (allOutlet) {
    eventName = 'Ingredient Recipes Create All Outlet';
  } else {
    eventName = 'Ingredient Recipes Create One Outlet';
  }

  pushClevertapEvent(eventName, {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'List of Outlets': outlets.map(outlet => outlet.id),
    Ingredient: recipe.recipe_ingredients.map(ri => ({
      'Ingredient Name': ri.ingredient_name,
      'Ingredient Quantity': ri.quantity,
      'Ingredient Unit': ri.unit_name,
    })),
  });
}

export function ingredientRecipesUpdate({ recipe }) {
  pushClevertapEvent('Ingredient Recipes Update One Outlet', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    Ingredient: recipe.recipe_ingredients.map(ri => ({
      'Current Ingredient Name': ri.ingredient_name,
      'Current Ingredient Quantity': ri.quantity,
      'Current Ingredient Unit': ri.unit_name,
    })),
  });
}

export function ingredientRecipesUpdateAllOutlet({
  previousRecipe,
  recipe,
  outlets,
}) {
  pushClevertapEvent('Ingredient Recipes Update All Outlet', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    'Previous Ingredient': previousRecipe.recipe_ingredients.map(ri => ({
      'Current Ingredient Name': ri.ingredient_name,
      'Current Ingredient Quantity': ri.quantity,
      'Current Ingredient Unit': ri.unit_name,
    })),
    Ingredient: recipe.recipe_ingredients.map(ri => ({
      'Current Ingredient Name': ri.ingredient_name,
      'Current Ingredient Quantity': ri.quantity,
      'Current Ingredient Unit': ri.unit_name,
    })),
    'List of Outlets': outlets.map(outlet => outlet.id),
  });
}

export function ingredientRecipesDelete({ recipe }) {
  pushClevertapEvent('Ingredient Recipes Delete One Outlet', {
    'Item Name': recipe.item_name,
    'Item Variant Name': recipe.item_variant_name,
    Ingredient: recipe.recipe_ingredients.map(ri => ({
      'Ingredient Name': ri.ingredient_name,
      'Ingredient Quantity': ri.quantity,
      'Ingredient Unit': ri.unit_name,
    })),
  });
}

export function importRecipeStart({ outletId }) {
  pushClevertapEvent('Import Recipe Start', {
    'Outlet Id': outletId,
  });
}

export function importRecipeSuccess({ outletId }) {
  pushClevertapEvent('Import Recipe Success', {
    'Outlet Id': outletId,
  });
}

export function importRecipeFailed({ outletId }) {
  pushClevertapEvent('Import Recipe Failed', {
    'Outlet Id': outletId,
  });
}
